import React from 'react';
import * as Yup from 'yup';
import { Formik, Field, FormikHelpers, FieldProps } from 'formik';
import { Typography, Spin, Input, Button } from 'antd';
import { FormField } from '../../components/FormField';

const { Text } = Typography;
const validationSchema = Yup.object({
  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$*.{}?"!@#%&/,><':;|_~`^\][)(]).+/,
      'Your password should contain at least 1 uppercase letter, lowercase letter, number and symbol'
    )
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Passwords must match'),
  code: Yup.string().required('The emailed code is required'),
});

type FormValues = {
  password: string;
  confirmPassword: string;
  code: string;
};
type Props = {
  onSubmit: (values: FormValues, actions: FormikHelpers<FormValues>) => any;
};

export const ForgotPasswordFinishForm = ({ onSubmit }: Props) => {
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{ password: '', confirmPassword: '', code: '' }}
      validationSchema={validationSchema}>
      {({ isSubmitting, status, handleSubmit }) => (
        <div className="flex flex-col pt-2">
          {status && <Text type="danger">{status}</Text>}
          <form onSubmit={handleSubmit}>
            <Field name="password">
              {(props: FieldProps) => (
                <FormField {...props}>
                  <Input.Password size="large" placeholder="Password" {...props.field} />
                </FormField>
              )}
            </Field>
            <Field name="confirmPassword">
              {(props: FieldProps) => (
                <FormField {...props}>
                  <Input.Password size="large" placeholder="Confirm Password" {...props.field} />
                </FormField>
              )}
            </Field>
            <Field name="code">
              {(props: FieldProps) => (
                <FormField {...props}>
                  <Input size="large" placeholder="Code" {...props.field} />
                </FormField>
              )}
            </Field>

            {isSubmitting ? (
              <div className="flex justify-center p-0">
                <Spin />
              </div>
            ) : (
              <div style={{ padding: 0 }}>
                <Button size="large" type="primary" htmlType="submit" className="login-form-button w-full">
                  Confirm
                </Button>
              </div>
            )}
          </form>
        </div>
      )}
    </Formik>
  );
};
